var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// React
import React from 'react';
import ReactDOM from 'react-dom';
// Redux
import FormWrapper from './components/FormWrapper';
import { makeStore, StoreContext } from './store/store';
// Service
import { getFormConfigData } from './services/digiUserProfile.service';
// Config
import { DIGI_FORM_DELETE_INIT_ATTR, DIGI_FORM_DELETE_REDIRECT_URL_ATTR, DIGI_FORM_DELETE_URL_ATTR, DIGI_FORM_SERVICE_ATTR, DIGI_FORM_STEPPER_ATTR, ROOT_CONTAINER_ID, } from './config/config';
import { getTheme } from './styles/theme';
// Material ui
import { Box, MuiThemeProvider, CircularProgress } from '@material-ui/core';
import DeleteAccount from './components/DeleteAccount';
/**
 * Display error
 * @param title
 * @param message
 */
var displayError = function (title, message) {
    var element = document.createElement('h2');
    element.innerText = title;
    var errorMessage = document.createElement('pre');
    errorMessage.innerText = message;
    document.body.appendChild(element);
    document.body.appendChild(errorMessage);
    throw new Error(title + " \n" + message);
};
/**
 * Get root element attributes
 * @param rootElement
 */
var getRootElementAttributes = function (rootElement) {
    var serviceName = rootElement.getAttribute(DIGI_FORM_SERVICE_ATTR);
    var stepper = rootElement.hasAttribute(DIGI_FORM_STEPPER_ATTR);
    var deleteAccountRedirectUrl = rootElement.getAttribute(DIGI_FORM_DELETE_REDIRECT_URL_ATTR) || undefined;
    var deleteAccountUrl = rootElement.getAttribute(DIGI_FORM_DELETE_URL_ATTR) || undefined;
    var deleteRequestInit = rootElement.getAttribute(DIGI_FORM_DELETE_INIT_ATTR) || undefined;
    if (serviceName) {
        return { stepper: stepper, serviceName: serviceName, deleteAccountUrl: deleteAccountUrl, deleteAccountRedirectUrl: deleteAccountRedirectUrl, deleteRequestInit: deleteRequestInit };
    }
    return;
};
/**
 * Check form initial values
 * @param initialValues
 */
var checkFormInitialValues = function (initialValues) {
    if (initialValues) {
        return true;
    }
    return typeof initialValues === 'object';
};
export var Profile = function (_a) {
    var serviceName = _a.serviceName, initialValues = _a.initialValues, handleSubmit = _a.handleSubmit, stepper = _a.stepper, deleteAccountUrl = _a.deleteAccountUrl, deleteUser = _a.deleteUser, deleteAccountRedirectUrl = _a.deleteAccountRedirectUrl, deleteRequestInit = _a.deleteRequestInit;
    var store = makeStore();
    var _b = React.useState({}), formState = _b[0], setFormState = _b[1];
    React.useEffect(function () {
        getFormConfigData(serviceName, initialValues)
            .then(function (_a) {
            var dataSchema = _a[0], uiSchema = _a[1];
            var theme = getTheme(uiSchema.theme);
            console.log(theme);
            setFormState(function (state) { return (__assign(__assign({}, state), { dataSchema: dataSchema, uiSchema: uiSchema, theme: theme })); });
        })
            .catch(function (error) {
            displayError('Configuration files not found', error);
        });
    }, [serviceName, initialValues]);
    if (!formState.dataSchema || !formState.uiSchema) {
        return React.createElement(CircularProgress, null);
    }
    return (React.createElement(StoreContext.Provider, { value: store },
        React.createElement(MuiThemeProvider, { theme: formState.theme },
            React.createElement(FormWrapper, { uiSchema: formState.uiSchema, handleSubmit: handleSubmit, dataSchema: formState.dataSchema, stepper: stepper, formData: initialValues }),
            !stepper && deleteAccountUrl &&
                React.createElement(Box, { m: 2 },
                    React.createElement(DeleteAccount, { theme: formState.theme, onDelete: deleteUser, deleteAccountUrl: deleteAccountUrl, deleteAccountRedirectUrl: deleteAccountRedirectUrl, deleteRequestInit: deleteRequestInit })))));
};
var initForm = function () {
    try {
        /** App store */
        var store_1 = makeStore();
        /** App root element */
        var rootContainer_1 = document.getElementById(ROOT_CONTAINER_ID);
        if (!rootContainer_1) {
            displayError('Root element not found', "Html root element with id attribute set to \"" + ROOT_CONTAINER_ID + "\" is required.");
        }
        else {
            var parameters = getRootElementAttributes(rootContainer_1);
            if (!parameters) {
                return displayError('Missing root element attributes', 'Attribute service is missing.');
            }
            var serviceName = parameters.serviceName, stepper_1 = parameters.stepper, deleteAccountUrl_1 = parameters.deleteAccountUrl, deleteAccountRedirectUrl_1 = parameters.deleteAccountRedirectUrl, deleteRequestInit_1 = parameters.deleteRequestInit;
            if (!checkFormInitialValues(window.initialValues)) {
                return displayError('Bad parameters initialValues', '"initialValues" must be a json object.');
            }
            var submit_1 = window.submit;
            if (!submit_1) {
                return displayError('Bad parameters submit', '"submit" parameters must be a json object with "url" property or a string.');
            }
            var deleteUser_1 = window.delete;
            /**
             * Handle form submission
             * @param data
             */
            var handleSubmit_1 = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    try {
                        submit_1(data);
                    }
                    catch (error) {
                        console.error(error);
                    }
                    return [2 /*return*/];
                });
            }); };
            getFormConfigData(serviceName, window.initialValues)
                .then(function (_a) {
                var dataSchema = _a[0], uiSchema = _a[1];
                var theme = getTheme(uiSchema.theme);
                ReactDOM.render(React.createElement(StoreContext.Provider, { value: store_1 },
                    React.createElement(MuiThemeProvider, { theme: theme },
                        React.createElement(FormWrapper, { uiSchema: uiSchema, handleSubmit: handleSubmit_1, dataSchema: dataSchema, stepper: stepper_1, formData: window.initialValues }),
                        !stepper_1 && deleteAccountUrl_1 &&
                            React.createElement(Box, { m: 2 },
                                React.createElement(DeleteAccount, { theme: theme, onDelete: deleteUser_1, deleteAccountUrl: deleteAccountUrl_1, deleteAccountRedirectUrl: deleteAccountRedirectUrl_1, deleteRequestInit: deleteRequestInit_1 })))), rootContainer_1);
            })
                .catch(function (error) {
                displayError('Configuration files not found', error);
            });
        }
    }
    catch (error) {
        console.error(error);
    }
};
export default initForm;
//# sourceMappingURL=digiForm.js.map